import React from 'react'

import { IndevaIFrame } from '../../../../core/components/IndevaIFrame'

export const Campaigns = () => {
  return <IndevaIFrame path="rankings/store" />
}
